module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_1-fef94590fc4868399db7931068eef19e.webp";